import { render } from "./RiskRegisterView.vue?vue&type=template&id=0e9c8264&scoped=true"
import script from "./RiskRegisterView.vue?vue&type=script&lang=js"
export * from "./RiskRegisterView.vue?vue&type=script&lang=js"

import "./RiskRegisterView.vue?vue&type=style&index=0&id=0e9c8264&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9c8264"]])

export default __exports__